var _g, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSchualedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.61902 20.6348C7.61902 15.8459 7.61902 13.4515 9.12532 11.9638C10.6316 10.4761 13.056 10.4761 17.9047 10.4761H23.0476C27.8963 10.4761 30.3207 10.4761 31.827 11.9638C33.3333 13.4515 33.3333 15.8459 33.3333 20.6348V23.1745C33.3333 27.9633 33.3333 30.3579 31.827 31.8455C30.3207 33.3332 27.8963 33.3332 23.0476 33.3332H17.9047C13.056 33.3332 10.6316 33.3332 9.12532 31.8455C7.61902 30.3579 7.61902 27.9633 7.61902 23.1745V20.6348Z",
    stroke: "#E86C00",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0476 10.4761V8.57129",
    stroke: "#E86C00",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.9048 10.4761V8.57129",
    stroke: "#E86C00",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.26184 16.8252H32.6904",
    stroke: "#E86C00",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.1904 26.9842C28.1904 27.6855 27.6148 28.254 26.9047 28.254C26.1946 28.254 25.619 27.6855 25.619 26.9842C25.619 26.2829 26.1946 25.7144 26.9047 25.7144C27.6148 25.7144 28.1904 26.2829 28.1904 26.9842Z",
    fill: "#E86C00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.1904 21.9046C28.1904 22.6059 27.6148 23.1744 26.9047 23.1744C26.1946 23.1744 25.619 22.6059 25.619 21.9046C25.619 21.2033 26.1946 20.6348 26.9047 20.6348C27.6148 20.6348 28.1904 21.2033 28.1904 21.9046Z",
    fill: "#E86C00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7619 26.9842C21.7619 27.6855 21.1862 28.254 20.4761 28.254C19.766 28.254 19.1904 27.6855 19.1904 26.9842C19.1904 26.2829 19.766 25.7144 20.4761 25.7144C21.1862 25.7144 21.7619 26.2829 21.7619 26.9842Z",
    fill: "#E86C00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7619 21.9046C21.7619 22.6059 21.1862 23.1744 20.4761 23.1744C19.766 23.1744 19.1904 22.6059 19.1904 21.9046C19.1904 21.2033 19.766 20.6348 20.4761 20.6348C21.1862 20.6348 21.7619 21.2033 21.7619 21.9046Z",
    fill: "#E86C00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3333 26.9842C15.3333 27.6855 14.7576 28.254 14.0476 28.254C13.3375 28.254 12.7618 27.6855 12.7618 26.9842C12.7618 26.2829 13.3375 25.7144 14.0476 25.7144C14.7576 25.7144 15.3333 26.2829 15.3333 26.9842Z",
    fill: "#E86C00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3333 21.9046C15.3333 22.6059 14.7576 23.1744 14.0476 23.1744C13.3375 23.1744 12.7618 22.6059 12.7618 21.9046C12.7618 21.2033 13.3375 20.6348 14.0476 20.6348C14.7576 20.6348 15.3333 21.2033 15.3333 21.9046Z",
    fill: "#E86C00"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0952 29.9998C18.0952 25.0029 22.146 20.9521 27.1428 20.9521C32.1397 20.9521 36.1905 25.0029 36.1905 29.9998V30.9521C36.1905 35.949 32.1397 39.9998 27.1428 39.9998C22.146 39.9998 18.0952 35.949 18.0952 30.9521V29.9998Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1429 36.9524C30.5408 36.9524 33.2952 34.0529 33.2952 30.4762C33.2952 26.8995 30.5408 24 27.1429 24C23.745 24 20.9905 26.8995 20.9905 30.4762C20.9905 34.0529 23.745 36.9524 27.1429 36.9524Z",
    stroke: "#E86C00",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5048 27.8091V30.8567",
    stroke: "#E86C00",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6762 33.1426L27.5048 30.8569",
    stroke: "#E86C00",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchualedIcon);
export default __webpack_public_path__ + "static/media/schualed-icon.c06e52e4dd31b876af78a8d5d423d2be.svg";
export { ForwardRef as ReactComponent };